import { Grid } from "@material-ui/core";
import { useFormikContext } from "formik";
import { FC } from "react";
import InputField from "src/components/ui-components/InputField";

type FormikContextType = {
	AzureFromAddress: string | null;
	AzureTenantId: string | null;
	AzureClientId: string | null;
	AzureClientSecret: string | null;
};

const AzureSettings: FC = () => {
	const { values, setFieldValue } = useFormikContext<FormikContextType>();

	return (
		<>
			<Grid container spacing={2}>
				<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
					<InputField
        	  name="AzureFromAddress"
        	  label="From *"
						value={values.AzureFromAddress}
						onChange={(event) => setFieldValue('AzureFromAddress', event?.target?.value || null)}
					/>
				</Grid>
				<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
					<InputField
        	  name="AzureTenantId"
        	  label="Tenant ID *"
						value={values.AzureTenantId}
						onChange={(event) => setFieldValue('AzureTenantId', event?.target?.value || null)}
					/>
				</Grid>
				<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
					<InputField
        	  name="AzureClientId"
        	  label="Client ID *"
						value={values.AzureClientId}
						onChange={(event) => setFieldValue('AzureClientId', event?.target?.value || null)}
					/>
				</Grid>
				<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
					<InputField
        	  name="AzureClientSecret"
        	  label="Client Secret *"
						value={values.AzureClientSecret}
						onChange={(event) => setFieldValue('AzureClientSecret', event?.target?.value || null)}
        	/>
				</Grid>
			</Grid>
		</>
	);
};

export default AzureSettings;